import { useQuery } from '@tanstack/react-query'

import { type DentalPlan } from 'components/member_onboarding_v2/types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

interface DentalPlansResponse {
  data: Array<DentalPlan>;
}

export function useGetDentalPlans ({
  enrollmentEventId,
}: {
  enrollmentEventId: string;
}) {
  return useQuery<DentalPlansResponse, GrapeAPIErrorType>({
    queryKey: ['enrollmentEvent', enrollmentEventId, 'dental_plans'],
    queryFn: async () => {
      const response = await fetchWithHeaders(
        `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/dental_plans`
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
          requestId: response.headers.get('x-request-id') ?? undefined
        })
      }
      return response.json()
    },
    retry: false,
  })
}
